module.exports = __webpack_public_path__ + "static/media/notification-teacher.eb6dddf2.svg";